var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import get from 'lodash.get';
import isEmpty from 'lodash.isempty';
import isEqual from 'lodash.isequal';
import { useEffect, useState } from 'react';
import { useFormContext, useWatch as formUseWatch, } from 'react-hook-form';
function mapWatchedValues(_a) {
    var _b;
    var watch = _a.watch, name = _a.name, getValues = _a.getValues, mapper = _a.mapper;
    if (!watch)
        return {};
    var _c = watch.defaultValue, defaultValue = _c === void 0 ? {} : _c;
    if (Array.isArray(name)) {
        var fields = name.reduce(function (acc, field) {
            var _a;
            var _b;
            return (__assign(__assign({}, acc), (_a = {}, _a[(mapper === null || mapper === void 0 ? void 0 : mapper[field]) || field] = (_b = getValues(field)) !== null && _b !== void 0 ? _b : get(defaultValue, field), _a)));
        }, {});
        return fields;
    }
    if (!name) {
        return getValues();
    }
    if (typeof name === 'string')
        return _b = {}, _b[(mapper === null || mapper === void 0 ? void 0 : mapper[name]) || name] = getValues(name), _b;
}
/**
 * wrapper around useWatch of react-hook-form
 * also allows to map the watched values providing custom mapper config
 * @param watch
 * @returns mapped values
 */
function useWatch(watch) {
    var _a = useFormContext(), control = _a.control, getValues = _a.getValues;
    var _b = watch || {}, name = _b.name, mapper = _b.mapper, defaultValue = _b.defaultValue;
    var disabled = isEmpty(watch);
    var watched = formUseWatch({ control: control, name: name, defaultValue: defaultValue, disabled: disabled });
    var _c = useState(mapWatchedValues({ watch: watch, name: name, getValues: getValues, mapper: mapper })), values = _c[0], setValues = _c[1];
    useEffect(function () {
        var nextValues = mapWatchedValues({ watch: watch, name: name, getValues: getValues, mapper: mapper });
        if (!isEqual(values, nextValues)) {
            setValues(nextValues);
        }
    }, [values, watched]);
    return values;
}
export default useWatch;
